/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { Grid, Box } from '@mui/material';
import EventCardCarousel from './Component/EventCardCarousel';
import { queryParams } from '../../../../../libs/HelperContent';
import { useDispatch, useSelector } from 'react-redux';
import { setEventsData } from '../../../../../redux/NewsFeedRedux';
import { getEvents } from '../../../../actions/recognition_actions';

// List of reactions
export const reactions = [
	{ key: 'r1', name: 'thumb', imgSrc: '/images/icons/thumbsup.svg', alt: 'thumb' },
	{ key: 'r2', name: 'star', imgSrc: '/images/icons/star.svg', alt: 'star' },
	{ key: 'r3', name: 'redheart', imgSrc: '/images/icons/redheart.svg', alt: 'redheart' },
	{ key: 'r4', name: 'clap', imgSrc: '/images/icons/clap.svg', alt: 'clap' },
	{ key: 'r5', name: 'shock', imgSrc: '/images/icons/shock.svg', alt: 'shock' }
];

const EventCards = () =>
{
	const activePath = window.location.pathname.split('/');
	const eventData: any = useSelector((state: any) => state?.mynewsFeed?.eventData);
	const session = useSelector((state: any) => state?.mysession?.session);
	const feedManagement = useSelector((state:any) => state?.mysession?.configs?.feedManagement);
	const dispatch = useDispatch();
	// state
	const [ selectedEvent, setSelectedEvent ] = useState({});
	// constant...
	const itemsPerPage = 3;
	// query
	const queryParamRes = queryParams(session?.userId, session?.companyId, session?.empRole, session?.role,	'get');

	const handleSelEvent = (ind:any) =>
	{
		setSelectedEvent(eventData[ind]);
	};

	const getEventsData = () =>
	{
		const currentDate = new Date().setHours(0, 0, 0, 0);
		let query = `?limit=${itemsPerPage}&currentDate=${currentDate}&startedAt=${currentDate}&timezone=${Intl.DateTimeFormat()
			.resolvedOptions()
			.timeZone.toString()}${queryParamRes}`;

		query += `${feedManagement?.feedsConfig?.occasions === false ? '&eventType = 1' : ''}`;

		getEvents(query)
			.then((res) =>
			{
				if (res.status)
				{
					// set currentIndex on initial call... to get reaction data.

					dispatch(setEventsData(res?.data));
				}
			})
			.catch((err) =>
			{
				console.log(err);
			});
	};

	useEffect(() =>
	{
		if (eventData?.length > 0)
		{
			setSelectedEvent(eventData[0]);
		}
	}, [ eventData ]);

	useEffect(() =>
	{
		// on initial render set the call eventData.
		if (session?.role !== 'individual' && !activePath.includes('celebrationevents'))
		{
			getEventsData();
		}
	}, [ ]);

	// Kept ui for conditional rendering...
	const isSelectedEvent = eventData && eventData?.length > 0;
	const boxStyles = {
		bgcolor      : isSelectedEvent ? 'var(--whiteColor)' : 'transparent',
		border       : isSelectedEvent ? '1px solid rgba(0, 0, 0, 0.12)' : 'none',
		borderRadius : isSelectedEvent ? '13px' : 0,
		padding      : isSelectedEvent ? '8px 8px' : '0',
		width        : isSelectedEvent ? 'var(--percent100)' : '0'
	};

	return (
		<Grid
			item
			mb={isSelectedEvent ? 2 : 0}
			// xs={isSelectedEvent ? 12 : 0}
			width='100%'
		>
			<Grid container height='auto' width='var(--percent100)'>
				<Box sx={boxStyles}>
					<Grid item xs={12}>
						<EventCardCarousel
							handleSelEvent={handleSelEvent}
							selEvent={selectedEvent}
							getEventsData={getEventsData}
						/>
					</Grid>
				</Box>
			</Grid>
		</Grid>
	);
};

export default EventCards;